export class QueryResultsModel {
	// fields
	items: any[];
	totalCount: number;
	errorMessage: string;
	content: [];
	totalElements: number;

	constructor(_items: any[] = [], _errorMessage: string = '', _totalCount?: number) {
		this.items = _items;
		this.totalCount = _totalCount !== undefined ? _totalCount : _items.length;
	}
}
